import React from "react";
import { Box, Button, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import usePostVehicleType from "../../../hooks/usePostVehicleType";

function VehicleType() {
  let [vehicleType, nameInput] = useInput({
    type: "text",
    label: "Vehicle Name"
  });
  let [labourRate, labourInput] = useInput({
    type: "number",
    label: "Special Labour Rate"
  });

  let [fixedHireCosts, fixedHireCostsInput] = useInput({
    type: "number",
    label: "Fixed Hire Costs"
  });

  fixedHireCosts = parseFloat(fixedHireCosts);

  const [, postVehicleType] = usePostVehicleType({
    name: vehicleType,
    special_labour_rate: labourRate,
    fixed_hire_costs: fixedHireCosts
  });

  const handleSubmit = () => {
    postVehicleType();
  };

  return (
    <Box className="settings_type">
      <details>
        <summary><Title>Add Vehicle Type</Title></summary>
      <Columns isMultiline>
        {nameInput}
        {labourInput}
        {fixedHireCostsInput}
      </Columns>
      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
      </details>
    </Box>
  );
}

export default VehicleType;
